export interface TrainingVersion {
  id: string;
  trainingId: string;
  title: string;
  description?: string | null;
  rank?: number;
  isAvailable: boolean;
  topicIds?: string[];
  relatedTopicIds?: string[];
  created: string;
  updated: string;
}

export type TrainingVersionFormData =
  & Omit<
    TrainingVersion,
    | "id"
    | "created"
    | "updated"
  >
  & {
    topicIds?: string[];
    relatedTopicIds?: string[];
  };

export const emptyTrainingVersion = (trainingId: string): TrainingVersionFormData => ({
  title: "",
  description: null,
  trainingId: trainingId,
  rank: 0,
  isAvailable: false,
  topicIds: [],
  relatedTopicIds: [],
});

export function trainingVersionToFormData(
  row: TrainingVersion | TrainingVersionFormData,
): TrainingVersionFormData {
  return {
    trainingId: row.trainingId,
    title: row.title,
    description: row.description ?? null,
    rank: row.rank,
    isAvailable: row.isAvailable,
    topicIds: row.topicIds ?? [],
    relatedTopicIds: row.relatedTopicIds ?? [],
  };
}
